module.exports = Studio.libraries['react-list'];


/*****************
 ** WEBPACK FOOTER
 ** external "Studio.libraries['react-list']"
 ** module id = 2
 ** module chunks = 0
 **/